/** Same slide-in toast pattern as Dashboard (PEAR brand colors). */
export const customToast = {
  show: (message: string, type: "success" | "error" | "info" | "warning" = "info") => {
    const toast = document.createElement("div");
    toast.className = `custom-toast ${type}`;
    toast.textContent = message;

    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      max-width: min(420px, calc(100vw - 40px));
      background: ${type === "success" ? "#43BE83" : type === "error" ? "#EA8F95" : type === "warning" ? "#FFA726" : "#5041BC"};
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      font-family: 'Nunito', sans-serif;
      font-weight: 600;
      font-size: 14px;
      z-index: 99999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.transform = "translateX(0)";
    }, 100);

    setTimeout(() => {
      toast.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toast.parentElement) document.body.removeChild(toast);
      }, 300);
    }, 4500);
  },
};
